import { Injectable } from '@angular/core';

import { AppTilesConfigService } from '../../app-tiles/shared/app-tiles-config.service';
import { OfficeHomePageErrorHandler } from '../../error-handler/error-handler.service';
import { Workload } from '../../shared/models/workload.model';
import { ConfigParserService } from '../../shared/services/config-parser.service';
import { DateService } from '../../shared/services/date.service';
import { OfficeWorkloadsService } from '../../shared/services/office-workloads.service';
import { ShellShimService } from '../../shared/services/shell-shim.service';
import { CapabilitiesService } from '../../shared/shared-context/capabilities.service';
import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { ContextService } from '../../shared/shared-context/context.service';
import { UrlBuilder } from '../../shared/utilities/url-builder.utility';
import { PwaNativeBridgeService } from './pwa-native-bridge.service';

/**
* Service that retrieves workload items as JSON.
*/
@Injectable()
export class PwaWorkloadsService extends OfficeWorkloadsService {
    private static readonly UpnRegex: RegExp = /auth_upn=(?:&|$)/gi;

    constructor(
        appTilesConfigService: AppTilesConfigService,
        capabilitiesService: CapabilitiesService,
        configParserService: ConfigParserService,
        contextService: ContextService,
        dateService: DateService,
        globalErrorHandler: OfficeHomePageErrorHandler,
        private readonly pwaNativeBridgeService: PwaNativeBridgeService,
        startupConfigService: ClientStartupConfigService,
        shellShimService: ShellShimService
    ) {
        super(appTilesConfigService, capabilitiesService, configParserService, contextService, dateService, globalErrorHandler, startupConfigService, shellShimService);
    }

    public getAdditionalWorkloads(): Promise<Array<Workload>> {
        return this.pwaNativeBridgeService.filterUninstalledApps(this.nativeWorkloads);
    }

    protected getMsaWorkloadsData(currentWorkloads: Array<Workload>): Promise<Array<Workload>> {
        currentWorkloads.forEach(workload => {
            // Replaces auth_upn parameter in client code because shell/config API is unauth for MSA
            if (PwaWorkloadsService.UpnRegex.test(workload.Url)) {
                // TODO: We are not using WindowService here because OfficeWorkloadsService calls getWorkloads() in the constructor and it
                // invokes this function before the instance variables are set up (pwaNativeBridgeService would be undefined, for example)
                // Need to do some refactoring there before we can safely use the service
                workload.Url = UrlBuilder.appendAndReplaceQueryParams(workload.Url, { 'auth_upn': this.startupConfigService.config.userPrincipalName || '' }, false);
            }
        });
        return Promise.resolve(currentWorkloads);
    }
}
